import dayjs from "dayjs";

import { UplotTooltipProps } from "@/utils/uplot-plugins/tooltip-plugin";

export const areaTooltipContent = ({
  priceIndex,
  areaColors,
  priceLabel,
  scoreLabels,
  scoreColors,
  valueFormatter,
}: {
  priceIndex: number;
  areaColors: string[];
  scoreLabels: string[];
  scoreColors: string[];
  priceLabel?: string;
  valueFormatter?: (value: unknown) => unknown;
}): UplotTooltipProps => ({
  content: (
    <div className="pointer-events-none rounded-lg bg-black p-4 text-white shadow-md">
      {/* Title */}
      <div className="flex justify-between gap-8 truncate py-1 pb-2 text-xs">
        <p className="text-xs" id="date" />
        <p
          className="rounded-full px-2 py-px text-xs font-medium text-gray-700"
          id="score"
        />
      </div>
      {/* Content */}
      <div className="flex justify-between gap-8 truncate py-1 pb-2 ">
        <p className="truncate text-xs sm:text-sm" id="label" />
        <p className="truncate text-xs font-medium sm:text-sm" id="price" />
      </div>
    </div>
  ),
  renderContent: ({ u, dataIndex, container }) => {
    const price = u.data[priceIndex][dataIndex];
    const score = u.data[priceIndex + 1][dataIndex] ?? 0;
    const date = dayjs.unix(u.data[0][dataIndex]).format("YYYY/MM/DD");

    const DateEl = container.querySelector("#date") as HTMLParagraphElement;
    DateEl.textContent = date;

    const ScoreEl = container.querySelector("#score") as HTMLParagraphElement;
    ScoreEl.textContent = score ? scoreLabels[score - 1] : "-";
    ScoreEl.style.color = score ? scoreColors[score - 1] : "white";
    ScoreEl.style.backgroundColor = score ? areaColors[score - 1] : "white";

    const LabelEl = container.querySelector("#label") as HTMLParagraphElement;
    LabelEl.textContent = priceLabel ?? u.series[priceIndex].label ?? "";

    const PriceEl = container.querySelector("#price") as HTMLParagraphElement;
    const formatter = valueFormatter ?? ((val) => val);
    PriceEl.textContent = formatter(price) as string;
  },
});
